import Alien from './alien';

export default class BrownAlien extends Alien {
    constructor(x, y) {
        super(x, y);
        this.anchor.set(0.5, 1);
        this.shadow.y -= 6;
        this.animations.add('idle', ["alienB_i.png"]);
        this.animations.add('move', ["alienB_m01.png", "alienB_m02.png", "alienB_m03.png", "alienB_m04.png", "alienB_m05.png"], 8, true);
        this.animations.add('attack', ["alienB_a01.png", "alienB_a02.png", "alienB_a03.png", "alienB_a04.png", "alienB_a05.png"], 8, true);
        this.animations.add('die', ["alienB_d01.png", "alienB_d02.png"], 8);
    }

    get eatSound() {
        return 'alien-4';
    }

    get corpseFrame() {
        return "alienB_d02.png";
    }

    get movingSpeed() {
        return 40;
    }

}


// WEBPACK FOOTER //
// ./src/objects/items/moveable/brown_alien.js